import { render, staticRenderFns } from "./JournalEntryDisplayDialog.vue?vue&type=template&id=44f13d28"
import script from "./JournalEntryDisplayDialog.vue?vue&type=script&lang=js"
export * from "./JournalEntryDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports